export default "__VITE_ASSET__DRClKgTb__"